// extracted by mini-css-extract-plugin
module.exports = {"template-modal":"TemplateModal_template-modal__VTBiu"};